/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import warehouseService from './../../../../services/warehouse';
import warehouseTransformer from './../../../../transformers/warehouse';
import Forms from './../../../../utils/forms/forms';
import partnerService from './../../../../services/partner';
import { fetchAllEquipments } from '../../../../store/actions';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        location: {
          value: '',
          type: 'text',
        },
        isBonded: {
          value: 0,
          type: 'switch',
        },
        partnerId: {
          value: '',
          type: 'select',
        },
      }),
      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
    ...mapGetters({
      allPartners: 'allPartners',
    }),
  },

  watch: {
    allPartners(allPartners) {
      this.formBasicInformation.setOptions('partnerId', allPartners);
    },
  },

  created() {
    this.formBasicInformation.hideField('partnerId');
    this.loading = true;
    Promise.all([
      partnerService.all(),
    ]).then(() => {
      this.loading = false;
    });
  },

  methods: {
    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = warehouseTransformer.send(
        Object.assign({}, this.formBasicInformation.data())
      );
      warehouseService.store(client)
        .then(() => {
          this.$message({
            message: this.$t('static.warehouse.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'warehouse.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
        });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/warehouse/create/create.js